<template>
  <div class="c-input c:row-center" :class="{ disabled, readonly }">
    <input
      class="input"
      :type="type"
      :maxlength="maxLength"
      :value="value"
      :readonly="readonly || disabled"
      :placeholder="placeholder"
      @input="onInput"
    />
    <div
      v-if="clearable && !disabled && value"
      class="clear"
      @click="throttledOnClearClick"
    >
      <img src="@/assets/icons/clear.svg" alt="" />
    </div>
    <div v-if="$slots.suffix" class="suffix">
      <slot name="suffix" />
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    value: String,
    disabled: Boolean,
    readonly: Boolean,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: "请输入",
    },
    maxLength: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
  },
  created() {
    this.throttledOnClearClick = throttle(this.clear, 500);
  },
  methods: {
    clear() {
      this.$emit("input", "");
      this.$emit("change", "");
    },
    onInput(e) {
      // console.log(e);
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
    },
  },
};
</script>

<style lang="less" scoped>
.c-input {
  box-sizing: border-box;
  width: 100%;
  height: 40/20rem;
  border: 1/20rem solid #c7c9cc;
  padding: 0;
  background-color: #fff;

  .input {
    flex: 1;
    width: 0;
    height: 38/20rem;
    padding: 0 12/20rem;

    line-height: 38/20rem;
    font-size: 14/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #000;

    &::placeholder {
      color: #666;
    }
  }

  .clear {
    box-sizing: border-box;
    width: 18/20rem;
    height: 38/20rem;
    padding: 11/20rem 1/20rem;
    font-size: 0;
    img {
      width: 16/20rem;
      height: 16/20rem;
    }
  }

  &.disabled,
  &.readonly {
    .input {
      color: #cfcfcf;
      &::placeholder {
        color: #cfcfcf;
      }
    }
  }
}
</style>
